import { Text } from '@make-software/tg-mini-app-ui';
import styled from 'styled-components';

export const ClaimedTitle = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.28px;
  line-height: 140%;
  font-family: 'Inter';
`;
